import React from 'react'
import { Modal } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { commonUtils } from '@/helpers/commonUtils'
import styles from './PackageExpiredModal.module.less'

export interface PackageExpiredModalProps {
  visible: boolean
  onClose: () => void
  onContact?: () => void
}

const PackageExpiredModal: React.FC<PackageExpiredModalProps> = ({
  visible,
  onClose,
  onContact,
}) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable
      closeIcon={<CloseOutlined />}
      onCancel={onClose}
      width={590}
      centered
      title={null}
      styles={{
        body: {
          padding: 0,
        },
        content: {
          padding: '40px 32px 40px',
          overflow: 'hidden',
          borderRadius: 18,
        },
      }}
      className={styles.packageExpiredModal}
    >
      <div className={styles.content}>
        <h2 className={styles.title}>套餐已过期</h2>
        <p className={styles.description} style={{ marginBottom: 10 }}>
          您的套餐已过期，可联系客服续费
        </p>

        <div className={styles.qrCodeSection}>
          <div className={styles.qrCode}>
            <img
              src={commonUtils.getStaticFile('images/customer_qr/pay_success.png')}
              alt='客服二维码'
            />
          </div>
          <div className={styles.right}>
            <p className={styles.qrCodeText}>
              <img src={commonUtils.getStaticFile('pc/pay/icon__niuma.png')} alt='客服' />
              添加专属客服，快速为您办理续费
            </p>
            <p className={styles.qrCodeHint}>(微信扫码即可添加)</p>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PackageExpiredModal
